import React, {Component} from "react";

export default class CriteriaPanel extends Component {

}